import React from "react";
import { FaEye, FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

export default function EmailLog() {
  return (
    <div>
      <div className="display-card table-responsive invoiceListing">
        <table className="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Recipients</th>
              <th>Email Detail</th>
              <th>Sent Dtae</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>12654</td>
              <td>
                To : testrepcts@gmail.com <br />
                CC. : testrepcts@gmail.com
              </td>
              <td>
                Subject: User credentials
                <br /> Application: Insurance
                <br /> Subcategory: MEMBER_REFERRAL
                <br />
                Email configuration name: RAW_TEMPLATE
                <br />
                Email setting: Corenroll(email-smtp.us-east-1.amazonaws.com)
              </td>
              <td>Jul 23, 2025 2:08 PM</td>
              <td>
                <div className="d-flex justify-content-around align-items-center">
                  <FaEye size={15} />
                  <FaRegEdit className="mx-2" size={15} />
                  <MdDelete
                    size={15}
                    //   onClick={() => {
                    //     handledeleteShow();
                    //     setDeleteid(customer?._id);
                    //   }}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
